module.exports = __webpack_public_path__ + "img/balanced.dd0e4332.jpg";